"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _svgs = require("svgs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Battery = function Battery(props) {
  return _react.default.createElement(_svgs.Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-battery"
  }, props.style), _react.default.createElement(_svgs.Rect, {
    x: 1,
    y: 6,
    width: 18,
    height: 12,
    rx: 2,
    ry: 2
  }), _react.default.createElement(_svgs.Path, {
    d: "M23 13v-2"
  }));
};

var _default = Battery;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/icons/Battery.js
// module id = ./node_modules/quark-core/components/icons/Battery.js
// module chunks = 0